import _ from "lodash";
import isFunction from "lodash/isFunction";
import axios from "axios";
import isArray from "lodash/isArray";
import { isEmpty, isTrue } from "../../../common/utils";
import fireDb from "../../../api/firebase/realtime/utils";
import { isElectronApp } from "../../../common/utils/electronAppHelper";
import { relationToNodes } from "../components/main/displayArea/drawSnaLxt/drawNetwork/SNAutils";
import ApiUrls from "../../../api/project/ApiUrls";
import ApiFunc from "../../../api/project/ApiFunc";
import { SNA_ANALYTICS_TYPE } from "../../../config/config.sna";

/* =========== dataset tool =========== */

export const getPersonalDataset = ({ userId, onSuccess, onNoData }) => {
  const handleSuccess = (files) => {
    const userFilesId = Object.entries(files || {})
      .filter(([fileUid, fileObj]) => fileObj.isOwner)
      // 區分正式站/測試站
      .filter(
        ([fileUid, fileObj]) =>
          fileObj.appWebMode === process.env.REACT_APP_WEB_MODE
      )
      .map(([fileUid, fileObj]) => fileUid);
    fireDb.getFilesInfoByIds(userFilesId, onSuccess, onNoData);
  };
  const handleNoData = () => {
    if (onNoData) onNoData();
  };
  // get users.uid.files
  fireDb.getUserFilesRt({
    uid: userId,
    onSuccess: handleSuccess,
    onNoData: handleNoData,
  });
};

//
export const getGroupDataset = ({ groupId, onSuccess, onNoData }) => {
  const handleSuccess = (files) => {
    const groupFilesId = Object.entries(files || {})
      .filter(([fileUid, fileObj]) => fileObj.isOwner)
      .map(([fileUid, fileObj]) => fileUid);
    fireDb.getFilesInfoByIds(groupFilesId, onSuccess, onNoData);
  };
  const handleNoData = () => {
    if (onNoData) onNoData();
  };
  // get users.uid.files
  fireDb.getGroupFilesRt({
    uid: groupId,
    onSuccess: handleSuccess,
    onNoData: handleNoData,
  });
};

export const deleteGroupFile = (fileId, groupId, onSuccess, onError) => {
  if (isElectronApp()) {
    // todo: local delete
  } else {
    // update firebase, soft delete
    // 從 users.uid.files 中刪除 file id
    const newData = {
      isOwner: false,
      uid: fileId,
    };
    //
    const handleSuccess = () => {
      const newData2 = { [groupId]: false };
      // files.[process.env.REACT_WEB_MODE].uid.groupowner.[groupId] 由 false 改為 true
      fireDb.updateFileGroup({
        fileUid: fileId,
        data: newData2,
        onSuccess,
        onError,
      });
    };

    const handleError = (err) => {
      if (onError) onError(err);
    };

    fireDb.deleteGroupSingleFile({
      groupId,
      fileUid: fileId,
      data: newData,
      onSuccess: handleSuccess,
      onError: handleError,
    });
  }
};

export const deleteUserFile = (fileId, userId, onSuccess, onError) => {
  if (isElectronApp()) {
    // todo: local delete
  } else {
    // update firebase, soft delete
    // 從 users.uid.files 中刪除 file id
    const newData = {
      isOwner: false,
      uid: fileId,
    };
    fireDb.updateUserFiles({
      userId,
      fileUid: fileId,
      data: newData,
      onSuccess,
      onError,
    });
  }
};

export const getPublicDataset = async ({ onSuccess, onNoData }) => {
  // [{
  //   cph: {
  //     // accessDiary: {development: 'true', production: 'true'}
  //     // accessDiary_hsna: {development: 'true', production: 'true'}
  //     // accessPages: {development: 'Ocr,Semantic,Person,GIS,Search', production: 'Ocr,Semantic,Person,GIS,Search'}
  //     // diaryGraph: "diary_cph"
  //     // diaryName: "蔡培火日誌"
  //     // public: true
  //     // public_hsna: "true"
  //     // relation: {targetId: 'PER3469', targetLabel: '蔡培火'}
  //     // settingGraph: "lxt_setting"
  //     // kinshipGraph: "diary_cph"  // e.g."diary_cph,diary" or "diary_cph"
  //   }
  // },{},..]
  const handleSuccess = (data) => {
    const datasetPublic = Object.entries(data).reduce(
      (acc, [diaryKey, objVal]) => {
        if (
          isTrue(objVal?.accessDiary_hsna?.[process.env.REACT_APP_WEB_MODE])
        ) {
          acc.push({
            id: diaryKey,
            uid: diaryKey,
            displayName: objVal?.diaryName || "",
            graph: objVal?.diaryGraph || "",
            targetId: objVal?.relation?.targetId || "",
            targetLabel: objVal?.relation?.targetLabel || "",
            kinshipGraph: objVal?.kinshipGraph || "", // 若有選擇該日誌時,要顯示那些 graph 的親屬關係事件類別(複選)
          });
        }
        return acc;
      },
      []
    );
    const sortKey = "displayName";
    const dataSort = _.sortBy(datasetPublic, sortKey);
    if (onSuccess) onSuccess(dataSort);
  };
  const handleNoData = () => {
    if (onNoData) onNoData();
  };
  // 搜尋 firebase 找到 public dataset 所有資料
  fireDb.getPublicDatasetRt({
    onSuccess: handleSuccess,
    onNoData: handleNoData,
  });
};

/**
 *
 * @param value {string|any}
 * @returns {string}
 */
const safeQueryParam = (value) => {
  if (!(value && typeof value === "string")) return "";
  if (value.toLowerCase() === "all") return "";
  return value;
};
/**
 *
 * @param list {*[]}
 * @returns {*}
 */
const safeList = (list) => list.filter((o) => !isEmpty(o));
// 從 api 取得資料庫的資料
export const getSnaDataFromApi = async (apiParams) => {
  const { graph, graphName, startDate, endDate } = apiParams;
  try {
    const url = ApiUrls.getSnaDatasetPublic()
      .replace("{limit}", -1)
      .replace("{offset}", 0)
      .replace("{graph}", graph)
      .replace("{startDate}", startDate)
      .replace("{endDate}", endDate);
    // response.data:
    // [
    //   {
    //     date: "1927-02-06",
    //     personTagStartPos: "119",
    //     eventTypeTagEndPos: "127",
    //     perId: "PER2132",
    //     eventTypeId: "EVTTYPE2",
    //     diaryId: "DIARY1927-02-06",
    //     eventTypeTagStartPos: "13",
    //     perLabel: "林炳文",
    //     content: "【Paragraph 1】製麻會社有土地二百二甲在北斗郡溪洲，擬欲賣人，得中前日曾來招余共買，按價格十二萬円，余為社長而暗與人合股買會社之土地，實為有損人格，故謝絕之。然其實在之價值若何，非斟酌而以賤價賣人，於會社殊為有損，本早乃命坤山、炳文往實地調查。並囑坤山以電話詢問台北謝春木，渭水確實被拘留乎。午後接其復信，始知其誤傳。【Paragraph 2】徐榮錦第一次來書請寄學費，則於一月十日電匯寄去，一週間即送還，謂受信移轉。第二次接其責問何故不送金，其住所與前次不同，則隨時用為替寄去。第三次接來書，言前緩﹝援﹞助而後不緩﹝援﹞助，比不緩﹝援﹞助竟害云云。余素不識其人，因聞賴國美來言其在東之困苦，乃自十四年起補助之，何意其人之無常識若是。本早接第二次寄去之為替，謂受信移轉，故送還。噫，彼三週間，住所改易三次，余送二次，皆無受信人，反來責余無告而斷絕送金，實為可惡可恨。余命榮鍾〔鐘〕修書，將此九十円再為寄交靈石轉交，此後決不願補助此無常識之人。【Paragraph 3】午後，同培火到五弟處，炳耀﹝曜﹞、[1]汝南、添丁亦到，閒談一時餘。【Paragraph 4】夜，與藤井夫婦、猶龍、愛子、培火、榮鍾〔鐘〕及內人共八人，食閏﹝潤﹞餅。",
    //     personTagEndPos: "121",
    //     eventTypeTag: "TAG_b66bd1a6-57b1-4a9c-87bf-7d9b3d556e6e",
    //     personTagLabel: "炳文",
    //   }
    // ]
    const response = await ApiFunc.readLxtData(url);
    // api 撈出的資料(事件可能包含/不包含作者)
    return {
      data: (response?.data || []).map((item) => ({
        ...item,
        event: item.eventTypeTag,
        id: item.perId,
        label: item.perLabel,
        group: graph,
        groupName: graphName,
      })),
      error: null,
    };
  } catch (err) {
    return {
      data: [],
      error: err.message,
    };
  }
};

/* ========== sna ========== */
const uniqEventKey = "event";
// 加入作者參與的事件
// 缺點: 作者會穩居中心,且佔比過大
const supplyDiaryAuthorEvent = (
  data = [],
  authorId,
  authorLabel,
  eventKey = uniqEventKey,
  supplyAuthorEvent = true
) => {
  if (!supplyAuthorEvent) return [...data];

  const eventMap = {};
  const supplyProp = [
    "event",
    "group",
    "groupName",
    "date",
    "eventTypeId",
    "diaryId",
    "eventTypeTagStartPos",
    "eventTypeTagEndPos",
    "content",
  ];
  // 取出所有的事件形成 Map
  data
    // .filter((item) => item.id !== authorId)
    .forEach((item) => {
      if (eventKey in item) {
        if (!(item[eventKey] in eventMap)) {
          eventMap[item[eventKey]] = {
            members: [item.id],
          };
          supplyProp.forEach((prop) => {
            if (prop in item) {
              eventMap[item[eventKey]][prop] = item[prop];
            }
          });
        } else {
          eventMap[item[eventKey]].members.push(item.id);
        }
      }
    });
  // 過濾出事件中沒有標記 author 的資要
  const authorEvent = Object.entries(eventMap).reduce(
    (acc, [evtKey, objVal]) => {
      if (!objVal.members.includes(authorId)) {
        const curObj = { id: authorId, label: authorLabel };
        // 只留必要的 prop
        supplyProp.forEach((prop) => {
          if (prop in objVal) {
            curObj[prop] = objVal[prop];
          }
        });
        acc.push(curObj);
      }
      return acc;
    },
    []
  );
  return [...data, ...authorEvent];
};

// 讀取開放日誌的資料(from api)
// 取得資料(過濾 graph, 時間),
export const getPublicDataSna = async (
  datasetPublic,
  apiParams,
  authorRemoveIds = []
) => {
  try {
    const publicDataset = (datasetPublic || []).filter((item) => item.checked);
    const apiQuery = [];
    publicDataset.forEach((item) => {
      apiQuery.push(
        getSnaDataFromApi({
          graph: item.graph,
          graphName: item.displayName,
          ...apiParams,
        })
      );
    });
    return Promise.all(apiQuery)
      .then((res) => {
        const errors = res.reduce((acc, cur) => {
          if (cur.error) {
            acc.push(cur.error);
          }
          return acc;
        }, []);

        return {
          data: res
            .reduce(
              (acc, cur, idx) => [
                ...acc,
                ...supplyDiaryAuthorEvent(
                  cur.data,
                  publicDataset[idx].targetId,
                  publicDataset[idx].targetLabel
                ),
              ],
              []
            )
            .filter((item) => !authorRemoveIds.includes(item.id)),
          error: errors.join(";"),
        };
      })
      .catch((err) => ({ data: [], error: err.message }));
  } catch (err) {
    return { data: [], error: err.message };
  }
};

/**
 * 取得開放日誌的詳細資訊
 *
 * @param params {{ids:string[],graphs:string[],inKinship:string}}
 * @param onStart
 * @param onSuccess
 * @param onError
 * @returns {Promise<void>}
 */
export const getPublicDataSnaDetail = async (
  params,
  onStart,
  onSuccess,
  onError
) => {
  try {
    const { ids, graphs, inKinship } = params || {};
    if (isFunction(onStart)) onStart();
    // 因為 url 有長度限制, 所以分次取得資料
    const itemsPerQuery = 5;
    const safeGraphs = Array.isArray(graphs) ? graphs : [graphs];
    const allQuery = [];
    safeGraphs.forEach((gr) => {
      const grStr = typeof gr === "string" ? gr : "";
      for (let i = 0; i < ids.length; i += itemsPerQuery) {
        const url = ApiUrls.getSnaDatasetPublicDetail()
          .replace("{limit}", -1)
          .replace("{offset}", 0)
          .replace(
            "{ids}",
            safeQueryParam(ids.slice(i, i + itemsPerQuery).join(","))
          )
          .replace("{graph}", grStr)
          .replace("{inKinship}", inKinship);

        // @ts-ignore
        allQuery.push(axios.get(url));
      }
    });

    const response = await Promise.all(allQuery);
    // @ts-ignore
    const data = response.reduce((acc, cur) => {
      if (isArray(cur?.data?.data)) {
        return [...acc].concat(cur.data.data);
      }
      return acc;
    }, []);
    // 有時 res.data.data 可能為 [{}]
    if (isFunction(onSuccess)) onSuccess(safeList(data));
  } catch (err) {
    // @ts-ignore
    if (isFunction(onError)) onError(err);
  }
};

// 取得使用者儲存在 server 的檔案
export const getSnaDataFromFileSever = (props) => {
  const { fileName, datasetId, datasetName } = props;
  // 後端讀取檔案後會轉成固定格式
  const url = ApiUrls.getExportReadFileSna().replace("{filename}", fileName);
  return new Promise((resolve, reject) => {
    axios
      .get(url)
      .then((res) => {
        let formatData = [];
        if (Array.isArray(res?.data?.data)) {
          formatData = res.data.data.map((item) => ({
            ...item,
            datasetId,
            datasetName,
          }));
        }
        resolve(formatData);
      })
      .catch((err) => {
        const customErr = new Error("檔案讀取失敗");
        reject(customErr);
      });
  });
};

// todo-desktop: 取得本地的資料(csv,...)
export const getSnaDataFromLocal = (datasetId) =>
  // todo: 取得 csv 檔案後,轉換格式
  // 取得 data 後, 轉換成固定的格式

  new Promise((resolve, reject) => {
    resolve([]);
  });
// 讀取團隊檔案的資料
export const getGroupDatasetSna = async (datasetGroup) => {
  try {
    // 依據 web app / electron app 切換取得資料的方式
    const getDataFunc = isElectronApp()
      ? getSnaDataFromLocal
      : getSnaDataFromFileSever;

    const datasetGroupChecked = (datasetGroup || []).filter(
      (item) => item.checked
    );
    const apiQuery = [];
    datasetGroupChecked.forEach((item) => {
      apiQuery.push(
        getDataFunc({
          ...item,
          datasetId: item?.uid,
          datasetName: item.displayName,
        })
      );
    });

    return Promise.all(apiQuery)
      .then((res) => {
        const totalRes = res.reduce((acc, cur) => [...acc, ...cur], []);
        // 轉換格式: relation 格式變成 nodes 格式
        return { data: relationToNodes(totalRes), error: null };
        // return relationToNodes(totalRes);
      })
      .catch(
        (err) => ({ data: [], error: err.message })
        // return [];
      );
  } catch (err) {
    return { data: [], error: err.message };
    // return [];
  }
};

/**
 * get top list
 * @param list {*[]}
 * @param num {number}
 *
 * @returns {*}
 */
const topList = (list, num = 5) => isArray(list) && list.slice(0, num);

/**
 * 取得要顯示的資料
 * @returns {[]|import("../../../../../common/utils/snaAnalysis/snaAnalysis").ValueList|any}
 */
export const getRows = (graph, method) => {
  if (!graph) return [];
  // 效能:graph instance 有記憶的功能,若已經計算過的數值會儲存起來,下次可以直接取用
  // return fakeRows;
  switch (method) {
    case SNA_ANALYTICS_TYPE.degreeCentrality.key:
      return graph.getDegreeCentrality();
    case SNA_ANALYTICS_TYPE.degreeCentralityStd.key:
      return graph.getDegreeCentralityStd();
    case SNA_ANALYTICS_TYPE.betweenCentrality.key:
      return graph.getBetweenCentrality();
    case SNA_ANALYTICS_TYPE.betweenCentralityStd.key:
      return graph.getBetweenCentralityStd();
    case SNA_ANALYTICS_TYPE.closeCentrality.key:
      return graph.getCloseCentrality();
    // case SNA_ANALYTICS_TYPE.eccentriCentrality.key:
    //   return graph.getEccentriCentrality();
    case SNA_ANALYTICS_TYPE.eigenvectorCentrality.key:
      return graph.getEigenvectorCentrality();
    case SNA_ANALYTICS_TYPE.pageRank.key:
      return graph.getPageRank();
    case SNA_ANALYTICS_TYPE.completeAnalysis.key:
      return {
        degreeCentralityStd: topList(graph.getDegreeCentralityStd()),
        betweenCentralityStd: topList(graph.getBetweenCentralityStd()),
        closeCentrality: topList(graph.getCloseCentrality()),
        eigenvectorCentrality: topList(graph.getEigenvectorCentrality()),
      };
    default:
      return [];
  }
};
